<div class="list-wrap content-wrap" style="padding-bottom: 0;">
    <div class="title my-color-blue">
        <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
    </div>

    <div class="small-text"><ion-skeleton-text animated style="width: 80%"></ion-skeleton-text></div>

    <app-skeleton-tasks></app-skeleton-tasks>
</div>

